import { useState, useEffect } from "react";
import { Navbar, Nav, Container,Badge } from "react-bootstrap";
import logo from '../assets/img/logo.jpeg';
import { HashLink } from 'react-router-hash-link';
import {
  BrowserRouter as Router
} from "react-router-dom";

export const NavBar = () => {

  const [activeLink, setActiveLink] = useState('home');
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    }

    window.addEventListener("scroll", onScroll);

    return () => window.removeEventListener("scroll", onScroll);
  }, [])

  const onUpdateActiveLink = (value) => {
    setActiveLink(value);
  }

  return (
    <Router>
      <Navbar expand="md" className={scrolled ? "scrolled" : " scrolled"}>
        <Container>
          <Navbar.Brand href="/" className="brand_name">
            <h2>
              <Badge bg="warning">NV</Badge> Concrete
            </h2>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav">
            <span className="navbar-toggler-icon"></span>
          </Navbar.Toggle>
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">
              <Nav.Link href="#home" className={activeLink === 'home' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('home')}>Home</Nav.Link>
              <Nav.Link href="#about" className={activeLink === 'abouts' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('abouts')}>Abouts</Nav.Link>
              <Nav.Link href="#plant" className={activeLink === 'plant' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('plant')}>Plant</Nav.Link>
              <Nav.Link href="#clients" className={activeLink === 'clients' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('clients')}>Clients</Nav.Link>
              <Nav.Link href="#director" className={activeLink === 'Directors' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('Directors')}>Directors</Nav.Link>
            </Nav>
            <span className="navbar-text">
              <HashLink to='#contact'>
                <button className="vvd"><span>Contact</span></button>
              </HashLink>
            </span>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </Router>
  )
}
